export default "__VITE_ASSET__a6f14f67__"